//------------------------------------------------------------------------------
//  This code was generated by typescript template tool 'Typewriter'.
//
//  Changes to this file may cause incorrect behavior and will be lost if
//  the code is regenerated.
//------------------------------------------------------------------------------

import { IModel } from "./Dental-DataModel-Interfaces-IModel";
import { Person } from "./Dental-DataModel-Models-Person";

export class Deposit  implements IModel {
    
    id: number;
    clientId: number;
    client: Person;
    createUserId: number;
    createUser: Person;
    createDate: any;
    lastEditUserId?: number;
    lastEditUser: Person;
    lastEditDate?: any;
    amount: number;
    paymentDate: any;
    archivedDate?: any;
    description: string;
}




  
